import { Box } from '@chakra-ui/react';

interface IProps {
	top: string;
	h: string;
}

export default function WeekCalendarDayHighLight(props: IProps) {
	return (
		<Box
			pointerEvents="none"
			userSelect="none"
			position="absolute"
			left={0}
			right={0}
			top={props.top}
			h={props.h}
			w="full"
			className="highlight"
			borderWidth={2}
			borderRadius="md"
			borderColor="red.400"
		/>
	);
}
